const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_PATTERN = /^[\d()+.\-\s]+$/;
const ZIP_PATTERN = /^\d{5}(?:-\d{4})?$/;
const CONTROL_CHARACTER_PATTERN = /[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/;

export function isValidText(value: unknown, maxLength: number, minLength = 1): value is string {
  return typeof value === 'string'
    && value.trim().length >= minLength
    && value.length <= maxLength
    && !CONTROL_CHARACTER_PATTERN.test(value);
}

export function isValidOptionalText(value: unknown, maxLength: number): boolean {
  return value === undefined || isValidText(value, maxLength);
}

export function isValidEmail(value: unknown): value is string {
  return typeof value === 'string' && value.length <= 254 && EMAIL_PATTERN.test(value);
}

export function isValidUsPhone(value: unknown): value is string {
  if (typeof value !== 'string' || !PHONE_PATTERN.test(value)) return false;
  const digits = value.replace(/\D/g, '');
  return digits.length === 10 || (digits.length === 11 && digits.startsWith('1'));
}

export function isValidZipCode(value: unknown): value is string {
  return typeof value === 'string' && ZIP_PATTERN.test(value);
}

export function isStrictlyOlderThan18(value: unknown, today = new Date()): value is string {
  if (typeof value !== 'string') return false;
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return false;

  const [, year, month, day] = match.map(Number);
  const birthDate = new Date(Date.UTC(year, month - 1, day));
  if (
    birthDate.getUTCFullYear() !== year
    || birthDate.getUTCMonth() !== month - 1
    || birthDate.getUTCDate() !== day
  ) return false;

  const eighteenthBirthday = new Date(birthDate);
  eighteenthBirthday.setUTCFullYear(year + 18);
  const todayUtc = Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate());
  return eighteenthBirthday.getTime() < todayUtc;
}
